module.exports = __webpack_public_path__ + "images/361a34c.png";